import type * as PublicType from '@/types/publicType'
import type {
  userInfoInterface,
  countryInterface,
  levelExperienceInterface,
  purseInterface
} from '@/types/apiType/userType'
import type { roomInfoInterface } from '~/types/apiType/roomType'
import type { queueInterface } from '@/types/viewsType/socketType'
import type { socketRoomInfoInterface } from '@/types/viewsType/roomType'

const defaultSocketRoomInfo: socketRoomInfoInterface = {
  publicChatSwitch: 1,
  micTotalCount: 10,
  giftEffectSwitch: 0,
  hideGiftBannerOpen: 0,
  showOtherEnterAnimSwitch: 0,
  charmSwitch: 0
}

const defaultLevelExperienceInfo: levelExperienceInterface = {
  uid: 0,
  avatar: '',
  level: 0,
  levelName: '', // 等级
  levelPercent: 0, // 金币等级百分比
  leftGoldNum: 0, // 升到下一级所需的金币数量
  leftExperience: 0,
  levelPic: '', // 等级图片
  levelRewardActSwitch: true, // 财富等级活动开关 预留
  levelRewardActUrl: '', // 财富等级活动Url
  erbanNo: 0,
  nick: ''
}

const defaultInfo: userInfoInterface = {
  uid: 0,
  erbanNo: 0,
  nick: '',
  gender: 0,
  avatar: '',
  userDesc: '',
  bestFriendNum: 0,
  followNum: 0,
  fansNum: 0,
  birth: 0,
  firstLanguage: '',
  country: '',
  countryInfo: {
    countryId: 0,
    countryName: '',
    countryNameAr: '',
    countryNameCn: '',
    countryNameVi: '',
    countryNameIn: '',
    countryNameEs: '',
    countryNameTw: '',
    countryNamePt: '',
    countryNameTh: '',
    countryCode: '',
    countryShort: '',
    countryIcon: '',
    circularIcon: '',
    countryLanguage: 0,
    continent: 0,
    sort: 0
  },
  freeCall: false,
  callDiamond: 0,
  isFans: false,
  agoraKey: '',
  liveRoomId: '',
  privatePhoto: [],
  isFirstCharge: false,
  userState: 0,
  videoRoomExperLevel: 0,
  videoRoomExperLevelPic: '',
  charmLevel: 0,
  charmLevelPic: '',
  isInvisible: false,
  vipDate: 0,
  vipIcon: '',
  vipId: 0,
  vipMedal: '',
  vipName: ''
}

const defaultRoomInfo: roomInfoInterface = {
  roomId: 0,
  uid: 0,
  nick: '',
  avatar: '',
  type: 0,
  videoChannel: 2,
  audioChannel: 4,
  roomLevelIcon: ''
}

const defaultCountryData: countryInterface = {
  countryId: 0,
  countryName: '',
  countryNameAr: '',
  countryNameCn: '',
  countryNameVi: '',
  countryNameIn: '',
  countryNameEs: '',
  countryNameTw: '',
  countryNamePt: '',
  countryNameTh: '',
  countryCode: '',
  countryShort: '', //国家编码 传参需要传入这个
  countryIcon: '',
  circularIcon: '',
  countryLanguage: 0,
  continent: 0,
  sort: 0
}

const defaultHostMinInfo: queueInterface = {
  key: -1,
  value: {
    mic_info: {
      position: 0,
      posState: 0,
      micState: 0
    },
    member: null,
    on_mic_type: 0
  }
}

const defaultQueueList: queueInterface[] = [
  {
    key: 0,
    value: {
      mic_info: {
        position: 0,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 1,
    value: {
      mic_info: {
        position: 1,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 2,
    value: {
      mic_info: {
        position: 2,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 3,
    value: {
      mic_info: {
        position: 3,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 4,
    value: {
      mic_info: {
        position: 4,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 5,
    value: {
      mic_info: {
        position: 5,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 6,
    value: {
      mic_info: {
        position: 6,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 7,
    value: {
      mic_info: {
        position: 7,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 8,
    value: {
      mic_info: {
        position: 8,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 9,
    value: {
      mic_info: {
        position: 9,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 10,
    value: {
      mic_info: {
        position: 10,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 11,
    value: {
      mic_info: {
        position: 11,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 12,
    value: {
      mic_info: {
        position: 12,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 13,
    value: {
      mic_info: {
        position: 13,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  },
  {
    key: 14,
    value: {
      mic_info: {
        position: 14,
        posState: 0,
        micState: 0
      },
      member: null,
      on_mic_type: 0
    }
  }
]

const defaultPurseInfo: purseInterface = {
  chargeGoldNum: 0, // 金币
  diamondNum: 0, // 钻石
  debrisNum: 0, // 碎片
  isFirstCharge: false // 是否首充
}

/**
 * 时间格式处理
 * @param {*} formatter 时间格式
 * @returns
 */
const _formatterNormalize = (formatter: string | (() => void)) => {
  if (typeof formatter === 'function') {
    return formatter
  }

  const formatterFunc = (dateInfo: PublicType.DateInfoProp) => {
    const { yyyy, MM, dd, HH, mm, ss, ms } = dateInfo
    return formatter
      .replace('yyyy', yyyy)
      .replace('MM', MM)
      .replace('dd', dd)
      .replace('HH', HH)
      .replace('mm', mm)
      .replace('ss', ss)
      .replace('ms', ms)
  }
  return formatterFunc
}

/**
 * 根据日期或时间戳获取年月日时分秒
 * @param {*} time 日期或时间戳
 * @param {*} formatter 需要展示的时间格式
 * @param {*} isPad 是否补0
 * @returns
 */
const formatterTime = (
  time: number | string,
  formatter: string | (() => void) = 'yyyy-MM-dd',
  isPad: boolean = true
) => {
  if (!time) return
  if (typeof time === 'string') {
    if (/^[0-9]+$/.test(time)) {
      // support "1548221490638"
      time = parseInt(time)
    } else {
      // support safari
      // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
      time = time.replace(new RegExp(/-/gm), '/')
    }
  }
  if (typeof time === 'number' && time.toString().length === 10) {
    time = time * 1000
  }
  const date = new Date(time)
  const formatterNew = _formatterNormalize(formatter)
  const dateInfo: PublicType.DateInfoProp = {
    yyyy: date.getFullYear().toString(),
    MM: (date.getMonth() + 1).toString(),
    dd: date.getDate().toString(),
    HH: date.getHours().toString(),
    mm: date.getMinutes().toString(),
    ss: date.getSeconds().toString(),
    ms: date.getMilliseconds().toString()
  }
  const _pad = (prop: keyof PublicType.DateInfoProp, len: number) => {
    dateInfo[prop] = dateInfo[prop]?.padStart(len, '0')
  }
  if (isPad) {
    _pad('yyyy', 4)
    _pad('MM', 2)
    _pad('dd', 2)
    _pad('HH', 2)
    _pad('mm', 2)
    _pad('ss', 2)
    _pad('ms', 3)
  }
  const result = formatterNew(dateInfo)
  return result
}

/**
 * 生成一个永不重复的ID
 * @param { Number } randomLength
 */
const getUuiD = (randomLength?: number) => {
  return Number(
    Math.random().toString().substr(2, randomLength) + Date.now()
  ).toString(36)
}

const stringifyDate = function (datetime, simple = false) {
  const i18n = useNuxtApp().$i18n
  const weekMap = [
    i18n.t('public.Sunday'),
    i18n.t('public.Monday'),
    i18n.t('public.Tuesday'),
    i18n.t('public.Wednesday'),
    i18n.t('public.Thursday'),
    i18n.t('public.Friday'),
    i18n.t('public.Saturday')
  ]
  // let weekMap = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  datetime = new Date(datetime)
  const year = datetime.getFullYear()
  const simpleYear = datetime.getYear() - 100
  let month = datetime.getMonth() + 1
  month = month > 9 ? month : '0' + month
  let day = datetime.getDate()
  day = day > 9 ? day : '0' + day
  let hour = datetime.getHours()
  hour = hour > 9 ? hour : '0' + hour
  let min = datetime.getMinutes()
  min = min > 9 ? min : '0' + min
  let week = datetime.getDay()
  week = weekMap[week]
  const thatDay = new Date(year, month - 1, day, 0, 0, 0).getTime()

  if (simple) {
    return {
      withYear: `${day}/${month}/${simpleYear}`,
      withMonth: `${month}-${day}`,
      withDay: `${week}`,
      withLastDay: `${i18n.t('public.Yesterday')}`,
      withHour: `${hour}:${min}`,
      thatDay
    }
  } else {
    return {
      withYear: `${year}-${month}-${day} ${hour}:${min}`,
      withMonth: `${month}-${day} ${hour}:${min}`,
      withDay: `${week} ${hour}:${min}`,
      withLastDay: `${i18n.t('public.Yesterday')} ${hour}:${min}`,
      withHour: `${hour}:${min}`,
      thatDay
    }
  }
}

/* 格式化聊天日期 */
const formatChatDate = function (datetime: number, simple = false) {
  const tempDate = new Date().getTime()
  const result = stringifyDate(datetime, simple)
  const thatDay = result.thatDay
  const deltaTime = (tempDate - thatDay) / 1000

  if (deltaTime < 3600 * 24) {
    return result.withHour
  } else if (deltaTime < 3600 * 24 * 2) {
    return result.withLastDay
  } else if (deltaTime < 3600 * 24 * 7) {
    return result.withDay
  } else if (deltaTime < 3600 * 24 * 30) {
    return result.withMonth
  } else {
    return result.withYear
  }
}

// 消息类型
const mapMsgType = function (msg) {
  const i18n = useNuxtApp().$i18n
  const map = {
    text: i18n.t('public.TM'), //'文本消息'
    image: i18n.t('public.PM'), //'图片消息'
    file: i18n.t('public.FM'), //'文件消息',
    audio: i18n.t('public.VM'), //'语音消息',
    video: i18n.t('public.VM2'), //'视频消息',
    geo: i18n.t('public.GM'), //'地理位置消息',
    tip: i18n.t('public.RM'), //'提醒消息',
    custom: i18n.t('public.CM'), //'自定义消息',
    notification: i18n.t('public.SN'), //'系统通知',
    robot: i18n.t('public.RM2') //'机器人消息'
  }
  const type = msg.type
  return map[type] || i18n.t('public.UM') //'未知消息类型'
}

// 解析scene 私聊还是群聊
const parseSession = function (sessionId: string) {
  if (/^p2p-/.test(sessionId)) {
    return {
      scene: 'p2p',
      to: sessionId.replace(/^p2p-/, '')
    }
  } else if (/^team-/.test(sessionId)) {
    return {
      scene: 'team',
      to: sessionId.replace(/^team-/, '')
    }
  }
}

//是否移动端
const isMobile = function () {
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  return flag
}

// Base64加密
const encryptParam = (param: string) => {
  const str = JSON.stringify(param)
  const Base64Str = window.btoa(str)
  return Base64Str
}

// Base64解密
const decryptParam = (Base64Str: string) => {
  const str = window.atob(Base64Str)
  const param = JSON.parse(str)
  return param
}

// 判断当前浏览器是否支持webp
const isLoadWebp = () => {
  if (process.client) {
    let ctx: HTMLCanvasElement | null = document.createElement('canvas')
    const reVal =
      ctx?.toDataURL('image/webp').includes('data:image/webp') || false
    ctx = null
    return reVal
  }
}

const canLoadWebp = isLoadWebp()

/**
 * 七牛云图片处理
 * https://developer.qiniu.com/dora/1279/basic-processing-images-imageview2
 * @param {string | undefined} picUrl 图片链接
 * @param {0 | 1 | 2 | 3 | 4 | 5} mode 默认：1，定义等比缩放、设定目标宽高缩放的多种不同方式，取值范围：[0,5]的整数
 * @param {number} w 裁剪宽度比例
 * @param {number} h 裁剪高度比例
 */
interface imageView2Interface {
  mode?: 0 | 1 | 2 | 3 | 4 | 5
  w?: number
  h?: number
}
const handlePicUrl = (
  picUrl: string | undefined,
  { mode = 1, w, h }: imageView2Interface = {}
): string => {
  if (!picUrl) return ''
  const runtimeConfig = useRuntimeConfig()
  if (picUrl.includes(runtimeConfig.public.qnUrl)) {
    // 七牛云
    let url = ''

    // 判断是否有图片瘦身前缀，有就直接复制url，没有就添加
    const imageslim = '?imageslim' // 片瘦身前缀
    if (picUrl.includes(imageslim)) {
      url = picUrl
    } else {
      url = picUrl + imageslim
    }

    // 判断缩放比例方式场景值
    if (mode || mode === 0) {
      const modeRegExp = /\|imageView2\/[0-5]/ // 正则表达式
      if (url.search(modeRegExp) !== -1) {
        url = url.replace(modeRegExp, `|imageView2/${mode}`)
      } else {
        url += `|imageView2/${mode}`
      }
    }

    // 添加裁剪比例宽
    if (w) {
      // 如果已有裁剪数值就移除重新添加
      const wRegExp = /\/w\/\d+/ // 正则表达式
      if (url.search(wRegExp) !== -1) {
        url = url.replace(wRegExp, `/w/${w}`)
      } else {
        url += `/w/${w}`
      }
    }
    // 添加裁剪比例高
    if (h) {
      // 如果已有裁剪数值就移除重新添加
      const hRegExp = /\/h\/\d+/ // 正则表达式
      if (url.search(hRegExp) !== -1) {
        url = url.replace(hRegExp, `/h/${h}`)
      } else {
        url += `/h/${h}`
      }
    }

    // 支持webp
    url = url.replace('/format/webp', '') // 过滤一次保证不重复添加
    if (canLoadWebp) {
      url += '/format/webp'
    }

    return url
  } else {
    return picUrl
  }
}

/**
 * 七牛云图片处理头像
 * @param {string | undefined} picUrl 图片链接
 */
const handlePicUrlAvatar = (picUrl: string | undefined): string => {
  return handlePicUrl(picUrl, { mode: 1, w: 140, h: 140 })
}

/**
 * 七牛云图片处理国家
 * @param {string | undefined} picUrl 图片链接
 */
const handlePicUrlCountryIcon = (picUrl: string | undefined): string => {
  return handlePicUrl(picUrl, { mode: 1, w: 40, h: 40 })
}

/**
 * 七牛云图片处理礼物
 * @param {string | undefined} picUrl 图片链接
 */
const handlePicUrlGift = (picUrl: string | undefined): string => {
  return handlePicUrl(picUrl, { mode: 1, w: 220, h: 220 })
}

/**
 * 七牛云图片处理会话
 * @param {string | undefined} picUrl 图片链接
 */
const handlePicUrlChatItem = (picUrl: string | undefined): string => {
  return handlePicUrl(picUrl, { mode: 0, w: 300 })
}

// 判断浏览器类型
const checkVersion = () => {
  const u = navigator.userAgent
  return {
    trident: u.indexOf('Trident') > -1, //IE内核
    presto: u.indexOf('Presto') > -1, //opera内核
    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios:
      !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
      !!u.match(/\(i[^;]+;(U;)?CPU[^)]+MacOSX/), //ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
    iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('iPad') > -1, //是否iPad
    webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
    weixin: u.indexOf('MicroMessenger') > -1, //是否微信
    qq: !!u.match(/\sQQ/i), //是否QQ
    facebook: u.indexOf('FBAN') > -1 || u.indexOf('FBAV') > -1, // 是否facebook
    webView:
      /webview/i.test(u) ||
      /wv/.test(u) ||
      (/iPhone|iPad|iPod/i.test(u) && /Safari/i.test(u) && !/Chrome/i.test(u)),
    app: u.indexOf('cocco') > -1 || u.indexOf('Cocco') > -1
  }
}

// 一维数组转二维数组
const arrayToMatrix = (arr, size) => {
  const result = [] as unknown[]
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size))
  }
  return result
}

// 处理毫秒 私聊页显示视频时长 时分秒
const formatOutput = (timeStamp: number) => {
  timeStamp = timeStamp / 1000
  const time = {
    h: '00',
    m: '00',
    s: '00'
  }
  // 获取时分秒
  const h = parseInt((timeStamp / 3600).toString())
  const m = parseInt(((timeStamp - h * 3600) / 60).toString())
  const s = timeStamp - h * 3600 - m * 60
  // 格式化
  time.h = h < 10 ? `0${h}` : h.toString()
  time.m = m < 10 ? `0${m}` : m.toString()
  time.s = s < 10 ? `0${s}` : s.toString()
  return `${time.h}:${time.m}:${time.s}`
}

// 把url参数转换成对象格式
function getQueryVariable(variable) {
  //获取当前URL中的查询字符串部分（即问号后面的部分）
  if (process.client) {
    const query = window.location.search.substring(1)
    //把查询字符串按照&符号分割成数组
    const vars = query.split('&')
    //遍历数组中的每个元素
    for (let i = 0; i < vars.length; i++) {
      //把当前元素按照=符号分割成键和值
      const pair = vars[i].split('=')
      //如果当前元素的键等于参数名，则返回对应的值
      if (pair[0] == variable) {
        return pair[1]
      }
    }
    //如果没有找到匹配的参数名，则返回false
    return false
  }
}

// 获取语言
function getBrowserLanguage() {
  if (process.client) {
    return navigator.language || ''
  }
}

// 异步加载script
function loadScript(url: string, id: string, callback) {
  // 如果有此DOM就不再添加
  if (document.getElementById(id)) return
  const script = document.createElement('script')
  script.id = id
  script.type = 'text/javascript'
  script.src = url

  // 脚本加载完成后执行回调函数
  script.onload = function () {
    callback()
  }

  document.head.appendChild(script)
}

/**
 * 格式化积分数值
 * @param {number | string} val 数值
 * @param {number} decimal 保留整数 默认：2
 * @param {Array<string>} units 单位数组 默认：['K', 'M', 'B']
 * @param {boolean} isFixed 是否固定保留decimal位小数 默认：false
 */
function valueToUnit(
  val?: number | string,
  decimal: number = 2,
  units: Array<string> = ['K', 'M', 'B'],
  isFixed: boolean = false
): string | number {
  if (!val) return 0
  val = Number(val)
  if (isNaN(val)) return val
  let index = -1
  while (val / 1000 >= 1 && index < units.length - 1) {
    val = val / 1000
    index++
  }
  val = Math.floor(val * Math.pow(10, decimal)) / Math.pow(10, decimal)
  if (isFixed) {
    val = Number(val).toFixed(decimal)
  }
  return val + (units[index] || '')
}

// 检测图片是否能正常请求
async function checkImageAvailability(imageUrl?: string) {
  if (!imageUrl) return Promise.resolve(false)
  return fetch(imageUrl, {
    method: 'HEAD' // 只请求头部信息
    // cache: 'no-cache' // 禁用缓存
  })
    .then((response) => {
      if (response.ok) {
        // 图片存在且可访问
        return true
      } else {
        // 图片无法访问，返回 false
        return false
      }
    })
    .catch(() => {
      // 网络错误或其他问题，返回 false
      return false
    })
}

/**
 * 阿拉伯数字转number数字
 * @param str 数字字符串/阿拉伯数字
 * @returns {string} 正常数字
 */
function convertArabicNumbers(str: string) {
  return str.replace(/[\u0660-\u0669]/g, (c) => {
    return String.fromCharCode(c.charCodeAt(0) - 0x0660 + 0x30)
  })
}

/**
 * 计算重叠区域
 * @param element1 元素1
 * @param element2 元素2
 */
function getElementsOverlap(
  element1: Element,
  element2: Element
): {
  isOverlapping: boolean
  height: number
  top?: number
  bottom?: number
} {
  const rect1 = element1.getBoundingClientRect()
  const rect2 = element2.getBoundingClientRect()

  // 检查是否有重叠
  const noOverlap =
    rect1.right < rect2.left ||
    rect1.left > rect2.right ||
    rect1.bottom < rect2.top ||
    rect1.top > rect2.bottom

  if (noOverlap) {
    return {
      isOverlapping: false,
      height: 0
    }
  }

  // 计算重叠区域
  const overlapTop = Math.max(rect1.top, rect2.top)
  const overlapBottom = Math.min(rect1.bottom, rect2.bottom)
  const overlapHeight = overlapBottom - overlapTop

  return {
    isOverlapping: true,
    height: overlapHeight,
    top: overlapTop,
    bottom: overlapBottom
  }
}

export default {
  defaultSocketRoomInfo,
  defaultInfo,
  defaultRoomInfo,
  defaultCountryData,
  defaultQueueList,
  defaultHostMinInfo,
  defaultLevelExperienceInfo,
  defaultPurseInfo,
  formatterTime,
  getUuiD,
  formatChatDate,
  mapMsgType,
  parseSession,
  isMobile,
  encryptParam,
  decryptParam,
  isLoadWebp,
  handlePicUrl,
  handlePicUrlAvatar,
  handlePicUrlCountryIcon,
  handlePicUrlGift,
  handlePicUrlChatItem,
  canLoadWebp,
  checkVersion,
  arrayToMatrix,
  formatOutput,
  getQueryVariable,
  loadScript,
  valueToUnit,
  getBrowserLanguage,
  checkImageAvailability,
  convertArabicNumbers,
  getElementsOverlap
}
